import { render, staticRenderFns } from "./InfoCardsBlock.vue?vue&type=template&id=511d0798&scoped=true&"
import script from "./InfoCardsBlock.vue?vue&type=script&lang=js&"
export * from "./InfoCardsBlock.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardsBlock.vue?vue&type=style&index=0&id=511d0798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511d0798",
  null
  
)

export default component.exports